import { isNil } from 'lodash';

import {
  safelyExtractTextFromHTML,
  SSMLAudio,
  SSMLAudioSchema,
  SupportedLanguages,
  VRCAudioMetadata,
} from '@pwp-common';

import { AudioFilesEditorOutput } from '../audio-files-editor-output';

export const audioFilesEditorOutputToDb = (params: {
  originalVrcAudioMetadata: VRCAudioMetadata;
  audioFilesEditorOutput: AudioFilesEditorOutput;
  audioURLsByLanguage?: Map<string, string>;
}): VRCAudioMetadata => {
  const { originalVrcAudioMetadata, audioFilesEditorOutput, audioURLsByLanguage } = params;

  if (isNil(originalVrcAudioMetadata) || isNil(audioFilesEditorOutput)) {
    return originalVrcAudioMetadata;
  }

  if (audioFilesEditorOutput.displayName && audioFilesEditorOutput.displayName.trim()) {
    originalVrcAudioMetadata.setDisplayName(audioFilesEditorOutput.displayName.trim());
  }

  for (const [languageCode, audioData] of Object.entries(audioFilesEditorOutput.audioByLanguage)) {
    const languageDefaults = SupportedLanguages.getDefaults(languageCode);

    const audioURL = audioURLsByLanguage?.get(languageCode);

    if (audioURL && audioURL.trim()) {
      const newSSMLAudio = new SSMLAudio({
        [SSMLAudioSchema.ssml]: SSMLAudioSchema.Defaults.ssml,
        [SSMLAudioSchema.audioURL]: audioURL,
        [SSMLAudioSchema.lastChangeTimeSSML]: SSMLAudioSchema.Defaults.lastChangeTimeSSML,
        [SSMLAudioSchema.lastChangeTimeAudio]: SSMLAudioSchema.Defaults.lastChangeTimeAudio,
      });
      originalVrcAudioMetadata.setAudioSSML(languageDefaults, newSSMLAudio);
    } else if (audioData.ssml && audioData.ssml.trim()) {
      const strippedInput = safelyExtractTextFromHTML(audioData.ssml);

      const newSSMLAudio = new SSMLAudio({
        [SSMLAudioSchema.ssml]: strippedInput,
        [SSMLAudioSchema.audioURL]: SSMLAudioSchema.Defaults.audioURL,
        [SSMLAudioSchema.lastChangeTimeSSML]: SSMLAudioSchema.Defaults.lastChangeTimeSSML,
        [SSMLAudioSchema.lastChangeTimeAudio]: SSMLAudioSchema.Defaults.lastChangeTimeAudio,
      });

      originalVrcAudioMetadata.setAudioSSML(languageDefaults, newSSMLAudio);
    } else {
      const originalSSML = originalVrcAudioMetadata.getAudio().get(languageCode)?.getSSML();
      const wasSSMLBacked = !isNil(originalSSML) && originalSSML.trim().length > 0;

      if (wasSSMLBacked) {
        const clearedSSMLAudio = new SSMLAudio({
          [SSMLAudioSchema.ssml]: SSMLAudioSchema.Defaults.ssml,
          [SSMLAudioSchema.audioURL]: SSMLAudioSchema.Defaults.audioURL,
          [SSMLAudioSchema.lastChangeTimeSSML]: SSMLAudioSchema.Defaults.lastChangeTimeSSML,
          [SSMLAudioSchema.lastChangeTimeAudio]: SSMLAudioSchema.Defaults.lastChangeTimeAudio,
        });
        originalVrcAudioMetadata.setAudioSSML(languageDefaults, clearedSSMLAudio);
      }
    }
  }

  return originalVrcAudioMetadata;
};
